/**
 * @generated SignedSource<<6d764043a9d8d9c8be6c79e1a8862114>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type HoleCount = "EIGHTEEN" | "NINE" | "NONE";
import { FragmentRefs } from "relay-runtime";
export type ConfigureRoundCourseLayoutControl_Booking$data = {
  readonly startSlot: {
    readonly permittedCourseLayouts?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly code: string;
          readonly holeCount: HoleCount;
          readonly id: string;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "ConfigureRoundCourseLayoutControl_Booking";
};
export type ConfigureRoundCourseLayoutControl_Booking$key = {
  readonly " $data"?: ConfigureRoundCourseLayoutControl_Booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"ConfigureRoundCourseLayoutControl_Booking">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ConfigureRoundCourseLayoutControl_Booking",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "startSlot",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "memberVisible",
                  "value": true
                }
              ],
              "concreteType": "CourseLayoutConnection",
              "kind": "LinkedField",
              "name": "permittedCourseLayouts",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CourseLayoutEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CourseLayout",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "id",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "holeCount",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "code",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": "permittedCourseLayouts(memberVisible:true)"
            }
          ],
          "type": "TimeSlot",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};

(node as any).hash = "ccfca6bfcb7adaad745461abd89de968";

export default node;
